import React, { useState } from 'react';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { ADD_CARD_PLACEHOLDER } from '../itemIds';
import FlipCardEditModal from '../flip-card/FlipCardEditModal';
import emptyImg from '~/training/sequence/templates/items/doorCard/empty.png';
import { useEditorStore } from '~/shell/Store';
import { AddCardOutline } from './AddCardOutline';

interface Props {
  width?: string;
  height?: string;
  text?: string;
  separateTitleAndBody?: boolean;
  maxCards?: number | null;
}

export type AddCardPlaceholderDefinition = ItemDefinition<
  typeof ADD_CARD_PLACEHOLDER,
  Props
>;

export class AddCardPlaceholder extends Item<
  typeof ADD_CARD_PLACEHOLDER,
  Props
> {
  protected render({
    width = '295.67px',
    height = '270px',
    text = 'Add a card',
    separateTitleAndBody = false,
    maxCards = 9
  }: RenderProps<Props>) {
    const { sequence, contentEditable } = useEditorStore();
    const [creatingId, setCreatingId] = useState<string | number | null>(null);
    const existingCardCount = (sequence?.items || []).filter(
      (it: any) => it?.__typename === 'Card'
    ).length;
    const limitReached = maxCards && existingCardCount >= maxCards;

    const handleAdd = () => {
      if (!contentEditable || !sequence || limitReached) return;
      // Create a temporary optimistic card subitem with a negative id (local) until user submits
      const tempId = `temp-${Date.now()}`;
      setCreatingId(tempId);
    };

    return (
      <>
        {!limitReached && (
          <AddCardOutline
            width={width}
            height={height}
            text={text}
            onClick={handleAdd}
          />
        )}
        {creatingId && (
          <FlipCardEditModal
            open={true}
            onClose={() => setCreatingId(null)}
            cardId={creatingId}
            isNew
            defaultImageUrl={emptyImg}
            separateTitleAndBody={separateTitleAndBody}
          />
        )}
      </>
    );
  }
}

registry[ADD_CARD_PLACEHOLDER] = AddCardPlaceholder;
